// Keeps a request draft's attached FILES across the sign-in redirect (owner,
// 2026-10-17: «اجعل الصوره محفوظه … بدون مايرجع يرفع الصوره مره اخرى»).
//
// A guest composes a request, attaches photos, taps send and is sent to
// /login/buyer. The typed fields survive in sessionStorage as JSON — but a
// File cannot be JSON-serialised, so the photos were silently dropped and the
// trader had to pick them again (RequestWizard showed a note saying so).
// IndexedDB stores File/Blob objects natively, so they come back as real
// files and upload exactly as if they had never left the form.
//
// Local to this browser only — nothing reaches storage until the request is
// actually sent (the upload still happens at submit, after sign-in). Every
// call is best-effort and never throws: a browser without IndexedDB (private
// mode in some browsers) simply behaves as before.
//
// Entries older than MAX_AGE_MS are ignored and removed, so an abandoned draft
// does not resurface on a later visit.

const DB_NAME = 'maabar_drafts';
const STORE = 'files';
export const MAX_AGE_MS = 24 * 60 * 60 * 1000;

function openDb() {
  return new Promise((resolve) => {
    try {
      if (typeof indexedDB === 'undefined') { resolve(null); return; }
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = () => { try { req.result.createObjectStore(STORE); } catch { /* exists */ } };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(null);
      req.onblocked = () => resolve(null);
    } catch { resolve(null); }
  });
}

function run(mode, fn) {
  return openDb().then((db) => new Promise((resolve) => {
    if (!db) { resolve(null); return; }
    try {
      const tx = db.transaction(STORE, mode);
      const out = fn(tx.objectStore(STORE));
      tx.oncomplete = () => { db.close(); resolve(out && 'result' in out ? out.result : true); };
      tx.onerror = () => { db.close(); resolve(null); };
      tx.onabort = () => { db.close(); resolve(null); };
    } catch { try { db.close(); } catch { /* noop */ } resolve(null); }
  }));
}

// files: File[] (or Blobs with a name). An empty list removes the entry.
export async function saveDraftFiles(key, files) {
  if (!key) return false;
  const list = (files || []).filter(Boolean);
  if (!list.length) return clearDraftFiles(key);
  const r = await run('readwrite', (s) => s.put({ savedAt: Date.now(), files: list }, key));
  return r !== null;
}

// -> File[] (possibly empty). Expired entries are removed and return [].
export async function loadDraftFiles(key, now = Date.now()) {
  if (!key) return [];
  const entry = await run('readonly', (s) => s.get(key));
  if (!entry || !Array.isArray(entry.files)) return [];
  if (!entry.savedAt || now - entry.savedAt > MAX_AGE_MS) { await clearDraftFiles(key); return []; }
  return entry.files.filter(Boolean);
}

export async function clearDraftFiles(key) {
  if (!key) return false;
  const r = await run('readwrite', (s) => s.delete(key));
  return r !== null;
}
